
import { useState, useEffect } from 'react';

interface PWAStatus {
  isIOS: boolean;
  isSafari: boolean;
  isStandalone: boolean;
  showInstallPrompt: boolean;
}

export function usePwaInstall(): PWAStatus & { closePrompt: () => void } {
  const [pwaStatus, setPwaStatus] = useState<PWAStatus>({
    isIOS: false,
    isSafari: false,
    isStandalone: false,
    showInstallPrompt: false,
  });

  useEffect(() => {
    // Определяем iOS устройство
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !(window as any).MSStream;

    // Определяем Safari браузер (не 100% точно, но достаточно для большинства случаев)
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

    // Определяем, запущено ли приложение в режиме standalone (с домашнего экрана)
    const isStandalone = window.matchMedia('(display-mode: standalone)').matches || 
                         (window.navigator as any).standalone === true;

    // Показываем промпт только если это iOS, Safari и не standalone
    const showInstallPrompt = isIOS && isSafari && !isStandalone;

    setPwaStatus({
      isIOS,
      isSafari,
      isStandalone,
      showInstallPrompt,
    });
  }, []);

  const closePrompt = () => {
    setPwaStatus(prev => ({ ...prev, showInstallPrompt: false }));
  };

  return { ...pwaStatus, closePrompt };
}
